




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import MonthlyProfitRateReport from '@/components/reports/MonthlyProfitRateReport.vue';
import MonthlyReportDate from '@/components/reports/MonthlyReportDate.vue';
import MixinProfitRateReport from '@/mixins/monthlyProfitRateReport.mixin';

@Component({
  components: { 
    Title, 
    MonthlyProfitRateReport, 
    MonthlyReportDate 
  },
  mixins: [MixinProfitRateReport]
})
export default class MPReport extends Vue {}
